module.exports = __webpack_public_path__ + "static/img/object_right_nosound.6acde61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/object_right_nosound.png
// module id = 270
// module chunks = 1